<template>
    
    <div class="papsi-wrapper">
        <h1 class="text-2xl font-semibold text-[#24723b] "> Option Modification</h1>
        <p class="text-xs text-[#747474] mt-2">Home / Option Modification / Position</p>
    </div>
    <div class="papsi-wrapper flex mt-7 flex-col">
        <div class="flex items-center gap-5">
            <h1 class="text-[#24723b] font-semibold text-lg">Search/Edit Position Portal</h1>
            <button v-on:click="HideView" class="bg-[#016B00] w-[180px] text-xs font-semibold p-2 rounded-md text-white hover:bg-[#CCAF12] py-3">+ Add Position</button>
        </div>
        <div class="papsi-container h-[300px]overflow-auto mt-3">
            <div class="flex w-full gap-3 mb-5">
                <input type="text"  @input="filteredOptions" placeholder="Search" class=" w-[500px]   border-[#b7b8b7] border p-2 px-5 rounded-md  outline-none  text-[#535353] text-sm" v-model="search">
                <select class="w-[150px]  border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#12760A] font-semibold outline-none" @change="filteredOptions" v-model="division_active" >
                    <option value="" selected disabled>Select Division</option>
                    <option value="ALL" >ALL</option>
                    <option v-for="(info,index) in $store.state.divisionList" :key="index" :value="info.division_code">{{ info.Abbreviation }}</option>
                </select>
                <select class="w-[150px]  border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#12760A] font-semibold outline-none" @change="filteredOptions" v-model="office" >
                    <option selected disabled>Select Office</option>
                    <option value="3" >ALL</option>
                    <option value="1" >Main Office</option>
                    <option value="0" >Satellite Office</option>
                </select>
            </div>
            <div class="mt-8 bg-[#f0f0f0] border-[#ffffff41] border-[3px] p-3 rounded-md shadow">
                <TableControl  :Action="true" :header="header" :column="column" :info="filteredData" :EButton="true" :DButton="false" @EditButton="EditButton" @DeleteButton="deletePosition"/>
            </div>
        </div>
    </div>
    <div v-if="AddPosition">
        <div @click="AddPosition = false" class="w-full h-[150%] fixed top-0 left-0 bg-[#00000063] z-30 backdrop-blur-[2px]">
        </div>
        <div class="flex fixed justify-center top-[20%] bottom-[20%]  left-[10%] right-[10%] items-center  z-40">
            <div class="flex flex-col justify-center  z-40 bg-white w-[500px] text-lg rounded-lg border-[2px] border-[#12760A] relative">
                <div class="pafcpic_header bg-[#12760A] py-3 px-6">
                    <p class="text-[#ffffff] text-md font-semibold">{{ type }}</p>
                </div>
                <div class="pafcpic_body py-3 px-6">
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Office</p>
                    <select  class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#016B00] font-semibold w-full outline-none" v-model="branch_code" @change="changeOffice">
                        <option selected disabled value="">Select Office</option>
                        <option value="1">Main Office</option>
                        <option value="0">Satellite Office</option>
                        <!-- <option v-for="(data, index) in $store.state.branch" :key="index" :value="data.br_code">{{ data.br_desc }}</option> -->
                    </select>
                    <div v-if="branch_code == '1'">
                        <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Division</p>
                        <select  class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#016B00] font-semibold w-full outline-none" v-model="divisionData" @change="changeDepartment">
                            <option selected disabled value="">Select Division</option>
                            <option v-for="(division, index) in $store.state.divisionList" :key="index" :value="division.division_code">{{ division.division_description }}</option>
                        </select>
                        <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Department</p>
                        <select  class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#016B00] font-semibold w-full outline-none" v-model="departmentID" @change="changeSection">
                            <option selected value="">N/A</option>
                            <option v-for="(department, index) in Department" :key="index" :value="department.department_code">{{ department.department }}</option>
                        </select>
                        <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Section</p>
                        <select  class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#016B00] font-semibold w-full outline-none" v-model="SectionData">
                            <option selected value="">N/A</option>
                            <option v-for="(section, index) in Section" :key="index" :value="section.section_code">{{ section.section }}</option>
                        </select>
                    </div>
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Category</p>
                    <select  class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#016B00] font-semibold w-full outline-none" v-model="CategoryValue">
                        <!-- <option v-for="(category, index) in Category" :key="index" :value="category.type">{{ category.title }}</option> -->
                        <option value="PJH">PROJECT HIRED</option>
                        <option value="RNF">RANK AND FILE</option>
                        <option value="SUP">SUPERVISOR</option>
                        <option value="AMG">ASSISTANT MANAGER</option>
                        <option value="MGR">MANAGER</option>
                        <option value="AVP">ASSISTANT VICE PRESIDENT</option>
                        <option value="VPR">VICE PRESIDENT</option>
                        <option value="EVP">EXECUTIVE VICE PRESIDENT</option>
                        <option value="PRE">PRESIDENT</option>
                    </select>
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Status</p>
                    <select  class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#016B00] font-semibold w-full outline-none" v-model="status">
                      <option value="0">INACTIVE</option>
                      <option value="1">ACTIVE</option>
                    </select>
                    <p class="text-xs text-[#868585] mb-1 ml-1 mt-2 font-medium">Position</p>
                    <input type="text" class="border-[#ACA9A9] border rounded-md py-3 px-3 text-sm text-[#016B00] font-semibold w-full outline-none" placeholder="Enter Position" v-model="Position">
                </div>
            <div class="pafcpic_footer flex gap-4 justify-end px-5 py-3 border-[#00800048] border-t font-medium">
                <button class="text-sm text-white bg-[#016B00] py-1.5 px-7 rounded-md w-[100px] text-center" v-if="Active === 'Add'" @click="addPosition">Add</button>
                <button class="text-sm text-white bg-[#016B00] py-1.5 px-7 rounded-md w-[100px] text-center" v-if="Active === 'Update'" @click="editPosition">Update</button>
                <button class="text-sm text-[#6A6A6A] bg-[#D9D9D9] py-1.5 px-7 rounded-md w-[100px] text-center" v-on:click="AddPosition = false">Cancel</button>
            </div>
        </div>
        </div>
    </div>

    <ValidPrompt v-if="Validationprompt" 
        @yes="confirmedDelete" 
        @cancel="cancelValidation" 
        :header="promtHead" 
        :header1="promtBody" 
        />

    <div v-if="Validation">
        <Prompt type="VALIDATION" @close="Validation = false"/>
    </div>

    <div v-if="Addpos">
        <Prompt type="ADDPOS" @close="Addpos = false"/>
    </div>
    <div v-if="deletePos">
        <Prompt type="DELETE" @close="deletePos = false"/>
    </div>

    <div v-if="Update">
        <Prompt type="UPDATEOPTION" @close="Update = false"/>
    </div>


</template>

<script>
import Services            from     '../../services/admin'
import Prompt              from     './Prompt/RequestPromt.vue'
import TableControl        from     "../controls/TableControl/TableControl.vue"
import ValidPrompt from './Prompt/ValidationPrompt.vue'
import { defineComponent } from     "vue";

export default defineComponent({
    components:{
        TableControl,
        Prompt,
        ValidPrompt
    },
    data(){
        return{
            office:             '3',
            branch_code:        '',
            filteredData:       '',
            search:             '',
            division_active:    'ALL',
            status:             "1",
            position_code:      null,
            promtHead:          null,
            promtBody:          null,
            Validationprompt:   false,
            type:'',
            Update: false,
            Addpos:         false,
            Validation:     false,
            info:           null,
            AddPosition:    false,
            Department:     '',
            divisionData:   '',
            departmentID:   '',
            Section:        '',
            SectionData:    '',
            CategoryValue:  'R',
            Position:       null,
            deletePos:  false,
            // Category:       [
            //     {
            //     title:      'Rank and File',
            //     type:       'R',
            //     },
            //     {
            //     title:      'Supervisor',
            //     type:       'S',
            //     },
            //     {
            //     title:      'Manager',
            //     type:       'M',
            //     },
            //     {
            //     title:      'Executive',
            //     type:       'E',
            //     }
            // ],
            header:[
                {title:'No.'},
                {title:'Position'},
                {title:'Office'},
                {title:'Division'},
                {title:'Category'},
                {title:'Status'},
                {title:'Action'}
            ],
            column:[
                'index',
                'position',
                'office',
                'division_code',
                'rank',
                'position_status',
            ],
        }
    },
    mounted(){
        
            this.getPosition()
        },
    methods:{
        changeOffice(){
            if(this.branch_code != '1'){
                this.divisionData = ''
                this.departmentID = ''
                this.SectionData = ''
            }
        },
        async EditButton(data){
            this.type              = "UPDATE POSITION"
            this.Active            = 'Update'
            this.EditID            =  data.id
            this.AddPosition       =  true
            this.branch_code       = data.office

            if(data.office == '1')
            {
                this.divisionData      =  data.division_code
                await this.changeDepartment()
                this.CategoryValue     =  data.rank
                this.Position          =  data.position
                this.status            =  data.position_status
                
                if(data.department_code == null)
                {
                    this.departmentID  =  ''
                }
                else
                {
                    this.departmentID  =  data.department_code
                    await this.changeSection()
                    this.SectionData   =  data.section_code
                }

                if(data.section_code == null)
                {
                    this.SectionData = ''
                }
            }
            else{
                this.CategoryValue     =  data.rank
                this.Position          =  data.position
                this.status            =  data.position_status
            }
           
        },
        cancelValidation(){
            this.Validationprompt = false
        },
        async confirmedDelete(){
            this.$emit("showLoader")
            this.Validationprompt = false
            const success =  await Services.deletePosition(this.position_code)
            const response =  success.success

            if(response == true){
                await this.getPosition()
                this.deletePos = true
            }
            else{
                this.$emit("hideLoader")
            }
        },          
        HideView(){
            this.divisionData = ''
            this.departmentID = ''
            this.SectionData = ''
            this.CategoryValue = 'R'
            this.Position = ''
            this.type = "ADD POSITION"
            if (!this.HideView == true){
                this.AddPosition = false
            }
            else{
                this.AddPosition = true
                this.Active = 'Add'
            }
        },
        async getPosition(){
            this.$emit("showLoader")
            const success        =  await Services.getPosition()
            this.info            =  success.data
            this.filteredData    =  success.data
            this.$emit("hideLoader")
        },
        async changeDepartment(){
            let that = this, state   = this.$store.state

            that.Department = state.departmentList.filter(div => div.division_code === this.divisionData);

            if(that.Department == ""){
                const sectionfilter = state.sectionList.filter(sec => sec.division_code === this.divisionData);
                that.Section = sectionfilter
            }
            else{
                const sectionfilter = state.sectionList.filter(sec => sec.division_code === this.divisionData && sec.department_code === null);
                that.Section = sectionfilter
            }
        },
         changeSection(){
            this.Section   = this.$store.state.sectionList.filter(sec=>sec.department_code === this.departmentID)
        },
        async addPosition(){
            this.$emit('showLoader')

            if(this.branch_code == '1' && !this.divisionData || !this.CategoryValue || !this.Position)
            {
                this.Validation = true
                this.$emit('hideLoader')
                return
            }

            const success       =  await Services.addPosition(this.divisionData,this.departmentID,this.SectionData,this.CategoryValue,this.Position,this.branch_code)
            this.deparment      =  success.data
            this.AddPosition    =  false
            this.getPosition()
            this.$emit('hideLoader')
            this.Addpos         =  true
       
        },
        async editPosition()
        {
            this.$emit('showLoader')
            await Services.editPosition(this.EditID,this.divisionData,this.departmentID,this.SectionData,this.CategoryValue,this.Position,this.status,this.branch_code)
            this.AddPosition    =  false
            this.getPosition()
            this.$emit('hideLoader')
            this.Update        =  true
        },
        async deletePosition(data){
            this.$emit('showLoader')
            this.position_code = data.position_code
            
            this.promtHead      = "DELETE POSITION"
            this.promtBody      = "Are you sure you want to delete this (position)?";
            this.Validationprompt = true
     
            this.$emit('hideLoader')
        },
        async filteredOptions() {
            this.loading = true
            this.search = this.search.toUpperCase()
            if(this.division_active != "ALL" && this.office == '3')
            {
                this.filteredData =   this.info.filter(
                details => 
                details.position && details.position.toLowerCase().includes(this.search.toLowerCase()) &&
                details.division_code && details.division_code.toLowerCase().includes(this.division_active.toLowerCase())
                )
            }
            else if(this.division_active == "ALL" && this.office != '3'){
                this.filteredData =   this.info.filter(
                details => 
                details.position && details.position.toLowerCase().includes(this.search.toLowerCase()) && 
                details.office && details.office.includes(this.office)      
                )
            }
            else if(this.division_active != "ALL" && this.office != '3'){
                this.filteredData =   this.info.filter(
                details => 
                details.division_code && details.division_code.toLowerCase().includes(this.division_active.toLowerCase()) && 
                details.position && details.position.toLowerCase().includes(this.search.toLowerCase()) && 
                details.office && details.office.includes(this.office)      
                )
            }
            else{
                this.filteredData =   this.info.filter(
                details => 
                details.position && details.position.toLowerCase().includes(this.search.toLowerCase()))
            }

            this.loading = false
        },

    }
    

})

</script>


